import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ApiResponse } from 'src/app/all-modules/shared/common-model/common.model';
import { DATE_FORMAT_CONSTATNS, MESSAGE_CATEGORY_CONSTATNS } from 'src/app/all-modules/shared/constants/constant';
import { laborAvailabilityViewModel, laborConfirmationDTO } from '../model/expose.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from 'src/app/all-modules/shared/services/spinner.service';
import { CommonToastService } from 'src/app/all-modules/shared/services/common-toast.service';
import { CommonService } from 'src/app/all-modules/shared/services/common.service';
import { ExposeService } from '../services/expose-service';

@Component({
    selector: 'app-labor-availability-confirmation',
    templateUrl: './labor-availability-confirmation.component.html',
    styleUrl: './labor-availability-confirmation.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LaborAvailabilityConfirmationComponent {
  linkUniqueKey = "";
  responseAvailability!: laborAvailabilityViewModel;
  DAY_NAME_MONTH_DAY_YEAR = DATE_FORMAT_CONSTATNS.DAY_NAME_MONTH_DAY_YEAR;
  isSuccess = false;
  constructor(private router: Router,
    private spinerService: SpinnerService, private commonToastService: CommonToastService, private route: ActivatedRoute,
    private commonService: CommonService, private spinnerService: SpinnerService, private exposeService: ExposeService) {
    this.route.params.subscribe(params => {
      this.linkUniqueKey = params['id']
    });
  }

  ngOnInit() {
    this.verifyLaborAvailabilityLink();
  }
  verifyLaborAvailabilityLink() {
    this.spinnerService.show();
    this.exposeService.verifyLaborAvailabilityLink(this.linkUniqueKey).subscribe({
      next: (response: laborAvailabilityViewModel) => {
        this.spinnerService.hide();
        this.responseAvailability = response;
      },
      error: (error) => {
        this.spinnerService.hide();
        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.LABOR_AVAILABILITY_SMS, error?.message);
        }
      }
    });
  }
  confirmAvailability(isAvailable:boolean) {
    if (!this.isSuccess) {
      this.spinnerService.show();
      let obj:  laborConfirmationDTO = {
        isConfirmLaborAvailability: isAvailable,
        linkUniqueKey:this.linkUniqueKey
      }
      this.exposeService.exposeConfirmLaborAvailability(obj).subscribe({
        next: (res: ApiResponse) => {
          if (res.success === true) {
            this.isSuccess = true;
          }
          this.spinnerService.hide();
          this.commonToastService.showToasterMessage(res.msgCategoryKey, res.msgCategoryTitle, res.message);
        },
        error: (error) => {
          this.spinnerService.hide();
          if (error?.status !== 401) {
            this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, error?.message);
          }
        }
      });
    }
  }
}
